import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getCacheGroupPoolingEligibility;

const DBO_POOLING_ELIGIBILITY_QUERY_KEY = 'dbo-pooling-eligibility';

const getPoolingEligibilityQueryKey = (cacheGroupId?: string) =>
  [DBO_POOLING_ELIGIBILITY_QUERY_KEY, cacheGroupId] as const;

const getPoolingEligibilityQueryOptions = ({
  cacheGroupId,
  enabled,
}: {
  cacheGroupId?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getPoolingEligibilityQueryKey(cacheGroupId),
    queryFn: async () => {
      const { data } = await apiFn({
        id: cacheGroupId!,
      });
      return data;
    },
    enabled: makeIsEnabled(!!cacheGroupId, enabled),
  });

type PoolingEligibilityQueryArgs = {
  cacheGroupId?: string;
  enabled?: boolean;
};

export const usePoolingEligibilityQuery = ({
  cacheGroupId,
  enabled,
}: PoolingEligibilityQueryArgs) => {
  return useQuery(getPoolingEligibilityQueryOptions({ cacheGroupId, enabled }));
};
